// utils/azureOpenAI.js
// Calls backend API which proxies to Azure OpenAI (avoids CORS issues)

export async function callAzureOpenAI(messages) {
  const server = process.env.REACT_APP_SERVER;

  if (!server) {
    throw new Error("Missing REACT_APP_SERVER in environment variables");
  }

  try {
    const response = await fetch(`${server}/api/chat`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ messages }),
    });

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || `HTTP ${response.status}`);
    }

    const data = await response.json();
    return data.choices[0].message.content;
  } catch (error) {
    console.error("Error calling chat API:", error);
    throw error;
  }
}
